import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { SharerService } from 'src/app/services/sharer.service';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidation } from 'src/app/helpers/customValidation';
declare var $: any;
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { AlertComponent } from '../../alert/alert.component';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-add-sharer-modal',
  templateUrl: './add-sharer-modal.component.html',
  styleUrls: ['./add-sharer-modal.component.css']
})
export class AddSharerModalComponent implements OnInit {

  @Input('ismodal') ismodal: any;
  @ViewChild('attachments') attachment: any;
  public environmentSettings: any;
  FileOrignalName: any;
  changedName: any
  PageTitle: any;
  addUPSISharer: FormGroup;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  documentType: any;
  otherDocumentName: any;
  disabledOnclick: boolean;
  sharerID: any;
  isEdit: any;
  checkUniqueEmail: any;
  checkOtherDocumentNoVal: boolean;
  checkOtherDocumentNoValD: boolean;
  panNumberReq: boolean;
  otherNumberReq: boolean;
  sharerName: any;
  fileSizeError: any;
  filesToUpload: any;
  DocumentFileDoc: any;
  FileNameO: any;
  isFileDeleted: any;
  ArrayOfSelectedFile = new Array<string>();
  fileList: File[] = [];
  listOfFiles: any[] = [];
  fileNameArray: any[] = [];
  DocumentArray: any[] = [];
  combineArray: any[] = [];
  current_date_of_doc: any;
  sharerDATAEdit: any;
  public ipLocalPc: any;
  DataList: any = [];
  public token: any = localStorage.getItem('token')
  fileExtension: boolean = true;
  // downloadURLForUPSI: any = environment.pssUrl + "upsi/sharerDoc/";
  downloadURLForUPSI: any = environment.pssServerUrl + "upsi/sharerDoc/";

  constructor(private sharerService: SharerService, private loaderService:LoaderService, private router: Router, private alert: AlertComponent, private activatedRoute: ActivatedRoute,
    public activeModal: NgbActiveModal, public commonFunction: CommonFunction, private location: Location, private customValidation: CustomValidation) { }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit(): void {
    this.loaderService.disable();
    // this.sharerService.getClientIp().subscribe((response) => {
    //   // console.log('responseresponseresponse',JSON.parse(response['_body']))
    //   // var ip = JSON.parse(response['_body']).ip;
    //   var ip = (response['ip']);
    //   this.ipLocalPc = ip
    // });

    this.isEdit = false;
    this.environmentSettings = environment;
    this.PageTitle = 'UPSI Sharer',
      this.addUPSISharer = new FormGroup({
        Name: new FormControl('', [
          Validators.required,
          this.noWhitespaceValidator,
          Validators.pattern('^[ a-zA-Z0-9!@#$^*%_?<>|=&()\\-`.+,:/\"]*'),
          Validators.maxLength(50),
          this.customValidation.inappropriateLanguageValidator.bind(this.customValidation)
        ]),
        EmpCode: new FormControl('', [Validators.pattern('^[ a-zA-Z0-9!@#$*%_?<>|=&()^\\-`.+,:/\"]*'), Validators.maxLength(25)]),
        Designation: new FormControl('', [Validators.pattern('^[ a-zA-Z0-9!@#$*%_?<>|=&()^\\-`.+,:/\"]*'), Validators.maxLength(50)]),
        Department: new FormControl('', [Validators.pattern('^[ a-zA-Z0-9!@#$*%_?<>|=&()^\\-`.+,:/\"]*'), Validators.maxLength(50)]),
        Unique_Identifier_Type: new FormControl('', [Validators.required]),
        Document_No: new FormControl('', []),
        email_id: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z0-9.-]{2,3}')]),
        ContactNumber: new FormControl('', [Validators.required]),
        tele_Number: new FormControl('', []),
        other_document_name: new FormControl('', [Validators.pattern('^[ a-zA-Z0-9!@#$*%_?<>|=&()^\\-`.+,:/\"]*'), Validators.maxLength(50)]),
      });



    this.activatedRoute.params.subscribe(params => {
      if (params['sharer']) {
        this.DataList = JSON.parse(params['sharer'])
      }
      if (params.dataArray) {
        let dataArray = (JSON.parse(params.dataArray));
        this.sharerID = dataArray['sharerId']
        this.DataList = dataArray['data']



        if (this.sharerID) {
          // this.sharerID = params['sharerId'];
          this.sharerService.editSharer(this.sharerID).subscribe((sharerDATA: HttpResponse<any>) => {
            this.sharerDATAEdit = sharerDATA;
            this.isEdit = true;
            this.sharerName = this.sharerDATAEdit.data[0].Name
            this.addUPSISharer.controls.Name.setValue(this.sharerDATAEdit.data[0].Name);
            this.addUPSISharer.controls.EmpCode.setValue(this.sharerDATAEdit.data[0].EmpCode);
            this.addUPSISharer.controls.Designation.setValue(this.sharerDATAEdit.data[0].Designation);
            this.addUPSISharer.controls.Department.setValue(this.sharerDATAEdit.data[0].Department);
            this.addUPSISharer.controls.Unique_Identifier_Type.setValue(this.sharerDATAEdit.data[0].Unique_Identifier_Type);
            this.addUPSISharer.controls.Document_No.setValue(this.sharerDATAEdit.data[0].Document_No);
            this.addUPSISharer.controls.email_id.setValue(this.sharerDATAEdit.data[0].email_id);
            this.addUPSISharer.controls.ContactNumber.setValue(this.sharerDATAEdit.data[0].ContactNumber);
            this.addUPSISharer.controls.tele_Number.setValue(this.sharerDATAEdit.data[0].tele_Number);
            this.addUPSISharer.controls.other_document_name.setValue(this.sharerDATAEdit.data[0].other_document_name);
            this.documentType = this.sharerDATAEdit.data[0].Unique_Identifier_Type;
            this.current_date_of_doc = this.sharerDATAEdit.data[0].CreatedDate;
            this.DocumentFileDoc = this.sharerDATAEdit.data[0].DocumentFile;
            this.DocumentArray = this.DocumentFileDoc.split(',');
            this.DocumentArray = this.DocumentArray.filter(function (e) { return e != ""; });

            try {
              this.fileNameArray = this.sharerDATAEdit.data[0].DocumentFile.split(',')
              this.fileNameArray = this.fileNameArray.filter(function (e) { return e != ""; });
            } catch {
              this.fileNameArray = (this.sharerDATAEdit.data[0].DocumentFile) ? this.sharerDATAEdit.data[0].DocumentFile.slice(this.sharerDATAEdit.data[0].DocumentFile.indexOf("-") + 1) : ""
            }

            this.FileNameO = (this.sharerDATAEdit.data[0].DocumentFile) ? this.sharerDATAEdit.data[0].DocumentFile.slice(this.sharerDATAEdit.data[0].DocumentFile.indexOf("-") + 1) : ""


          });

        }
      }
    });
  }

  noWhitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }
  downloadFile(filename) {
    window.location.href = this.downloadURLForUPSI + filename + "/" + this.token;
  }

  deleteFile(index) {
    this.DocumentArray.splice(index, 1);
    this.fileNameArray.splice(index, 1);
    //this.DocumentFileDoc.splice(index,1);
    this.isFileDeleted = true;

    //delete newSharer.DocumentFile;
    // var sharerData = { 'sharerData': newSharer, 'sharerId': sharerID }
    //console.log("sharerData*******************************", sharerData);
    this.activatedRoute.params.subscribe(params => {
      if (params['sharerId']) {
        this.sharerID = params['sharerId'];
        new Promise(resolve => this.sharerService.removeSharer(this.sharerID).subscribe((response) => {

          if (response.status == 1) {
            if (this.ismodal) {
              this.activeModal.dismiss('dismiss')
            }
            this.alert.error(JSON.stringify(response.err_fields) + ' fields are required or invalid.')

          }
        }))
        //this.sharerService.deleteSharer(this.sharerID)
      }
    });
  }
  initiateUploadDocument($event) {
    // console.log(data);

    // $("#documentUploadLable").html("Upload Notice Doc.");
    $("#UpsiUploadTitle").html("Attachment For UPSI");
    $("#upiSharerUploadDialog").modal('toggle');
  }
  onFileChanged(event: any) {
    var sharerID = this.sharerID;
    var date = new Date();
    var timestamp = date.getTime();
    if (this.fileList.length + event.target.files.length <= 10) {
      for (var i = 0; i <= event.target.files.length - 1; i++) {
        this.filesToUpload = event.target.files[i];
        let fileObj = {
          target: {
            files: [this.filesToUpload]
          }
        }
        if (this.commonFunction.checkFileExtension(fileObj)) {

          var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj, fileObj)
          if (filenameValidation == "Valid") {
            this.fileList.push(this.filesToUpload);
            this.listOfFiles.push(this.filesToUpload.name);
          } else {
            this.alert.error(filenameValidation);
          }


        } else {
          this.alert.error("Invalid file extension")
        }
      }
    } else {
      this.alert.error("Number of files cannot be more than 10");
    }
    this.attachment.nativeElement.value = '';

  }
  removeSelectedFile(index) {
    // Delete the item from fileNames list
    this.listOfFiles.splice(index, 1);
    // delete file from FileList
    this.fileList.splice(index, 1);
  }




  addAndUpdateSharer() {

    this.disabledOnclick = true;
    var sharerID = this.sharerID;
    var date = new Date();
    var timestamp = date.getTime();
    // let showMsg=false;
    // var panNo;  
    //   this.DataList.filter(item=>{  
    //     if(item.Document_No==this.addUPSISharer.controls.Document_No.value){
    //         showMsg=true;
    //         panNo=item.Document_No;
    //     }
    //   }
    //  )
    //  if(showMsg){
    //   this.alert.error( JSON.stringify(panNo) + ' PAN number is already use')
    //   return;
    // }

    var newSharer = {
      Name: (this.addUPSISharer.controls.Name.value) ? this.addUPSISharer.controls.Name.value.trim() : "",
      EmpCode: (this.addUPSISharer.controls.EmpCode.value) ? this.addUPSISharer.controls.EmpCode.value.trim() : "",
      Designation: (this.addUPSISharer.controls.Designation.value) ? this.addUPSISharer.controls.Designation.value.trim() : "",
      Department: (this.addUPSISharer.controls.Department.value) ? this.addUPSISharer.controls.Department.value.trim() : "",
      Unique_Identifier_Type: (this.addUPSISharer.controls.Unique_Identifier_Type.value) ? this.addUPSISharer.controls.Unique_Identifier_Type.value.trim() : "",
      Document_No: (this.addUPSISharer.controls.Document_No.value) ? this.addUPSISharer.controls.Document_No.value.trim() : "",
      email_id: (this.addUPSISharer.controls.email_id.value) ? this.addUPSISharer.controls.email_id.value.trim().toLowerCase() : "",
      ContactNumber: (this.addUPSISharer.controls.ContactNumber.value) ? this.addUPSISharer.controls.ContactNumber.value : "",
      tele_Number: (this.addUPSISharer.controls.tele_Number.value) ? this.addUPSISharer.controls.tele_Number.value : "",
      other_document_name: (this.addUPSISharer.controls.other_document_name.value) ? this.addUPSISharer.controls.other_document_name.value : "",
      DocumentFile: [] as any,
      ip_address: this.ipLocalPc,
    }

    this.listOfFiles = this.listOfFiles.map(f => { return `${timestamp}-${f}` });

    //this.fileList = this.fileList.map(f =>{return `${timestamp}-${f.name}`})

    this.combineArray = this.listOfFiles.concat(this.fileNameArray);
    var removeNullElementFromArray = this.combineArray.filter(function (e) { return e != null; });
    newSharer.DocumentFile.push(removeNullElementFromArray);
    newSharer.DocumentFile = newSharer.DocumentFile.join(',')
    // newSharer.DocumentFile.push(this.fileNameArray);
    // console.log(newSharer.DocumentFile);

    // if (!this.filesToUpload ) {
    //   delete newSharer.DocumentFile;
    // }
    // console.log('newSharer',newSharer)

    // if(this.isFileDeleted && this.filesToUpload == undefined  ){
    //   newSharer.DocumentFile =  null
    // }
    var sharerData = { 'sharerData': newSharer, 'sharerId': sharerID }

    new Promise(resolve => this.sharerService.addSharer(sharerData).subscribe((response) => {
      if (response.status == 1) {
        this.disabledOnclick = true;
        if (this.ismodal) {
          this.activeModal.dismiss('dismiss')
        }
        if (response.err_fields) {
          this.alert.error(JSON.stringify(response.err_fields) + ' fields are required or invalid.')
        } else {
          this.alert.error(response.message)
        }

      } else {
        var sharerIdDoc;
        if (response.data._id) {
          sharerIdDoc = response.data._id;
        } else {
          sharerIdDoc = sharerID
        }

        if (this.filesToUpload && this.fileExtension) {
          this.makeFileRequest(environment.pssServerUrl + "upsi/documentsFile/" + sharerIdDoc, timestamp, this.fileList, 'UPSI').then((result) => {
            if (this.ismodal) {
              this.activeModal.close(response)
            } else {
              this.alert.successWithOk(response.message, 'userMaster/upsisharer');
            }

          }, (error) => {
            this.alert.errorWithOk(error, 'userMaster/upsisharer');
          });
        } else {
          if (this.ismodal) {
            this.activeModal.close(response)
          } else {
            this.alert.successWithOk(response.message, 'userMaster/upsisharer');
          }
        }

      }

    }))
  }


  makeFileRequest(url: string, params: any, files: Array<File>, title: string) {
    var docArray = [];
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        //formData.append("file", files[i], params+"-"+files[i].name.replace(',', ''));
        //formData.append("file", files[i], params + "-" + files[i].name.replace(',', ''));
        var name = params + '-' + files[i].name.replace(',', '');
        // name = name.replace('(', '');
        // name = name.replace(')', '');
        //name = name.replace(new RegExp('\\(', 'g'), '');
        //name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = name;

      }
      var documentManagement = {
        "UPSIDocumentManagement": {
          DocumentName: title + Date.now() + this.FileOrignalName,
          DateOfDocument: new Date(),
          Upload: this.changedName,
          originalname: this.FileOrignalName,
          CompletedDate: null,

        }
      }
      // docArray.push(formData);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.setRequestHeader('userdetail', this.getUserDetail())
      xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
      xhr.send(formData);
    });
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 10) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  clear() {
    this.disabledOnclick = false;
    this.addUPSISharer.reset();
    this.ngOnInit();
  }

  back() {
    this.disabledOnclick = false;
    this.addUPSISharer.reset();
    this.ngOnInit();
    this.location.back(); // Navigate back to the previous page
  }

  onChangeUIType() {
    if (this.addUPSISharer.controls.Unique_Identifier_Type.value != '') {
      this.documentType = this.addUPSISharer.controls.Unique_Identifier_Type.value;

    }

    this.addUPSISharer.controls.other_document_name.setValue(null);
    this.addUPSISharer.controls.Document_No.setValue(null);

    if (this.documentType == 'Other') {
      this.otherDocumentName = true;
      this.otherNumberReq = true;
      this.panNumberReq = false;
      this.checkOtherDocumentNoValD = false;
    } else {
      this.otherDocumentName = false;
      this.panNumberReq = true;
      this.otherNumberReq = false;
      this.checkOtherDocumentNoVal = false;
    }
  }

  otherDocumentNameFun(ev) {


    if ((ev.target.value).length < 1) {
      this.otherDocumentName = true;
    } else {
      this.otherDocumentName = false;
    }
  }

  otherDocumentValidation(ev) {
    var oDno = ev.target.value;
    if (oDno.trim().length) {
      if (!(/'/.test(oDno))) {
        this.checkOtherDocumentNoVal = false;
        this.otherNumberReq = false;
      } else {
        this.checkOtherDocumentNoVal = true;
      }

    } else {
      this.checkOtherDocumentNoVal = true;
    }
  }


  DocumentValidation(ev) {
    var oDno = ev.target.value;
    if (oDno.trim().length) {
      if (/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(oDno)) {
        this.checkOtherDocumentNoValD = false;
        this.panNumberReq = false;
      } else {
        this.checkOtherDocumentNoValD = true;
      }

    } else {
      this.checkOtherDocumentNoValD = true;
    }
  }

  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData = resources.filter(function (item) {
      return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
    if (resourcesData) {
      upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
      upsiAdmin = false
    }
    var decrEmailId = this.commonFunction.decrypt(user.EmailId);
    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      upsiAdmin: upsiAdmin,
      // EmailId: user.EmailId,
      EmailId: decrEmailId,
      companyDetails: companyDetails,
      title: user.Title
    }
    return JSON.stringify(loginUser);
  }



  checkuniqueEmail(ev) {
    if ((ev.target.value).length) {
      var email_id = ev.target.value;
      this.sharerService.CheckUniqeEmailWithInCmp(email_id).subscribe((sharerDATA: any) => {
        if (sharerDATA.status == 0) {
          if (this.sharerID == sharerDATA.data[0]._id) {
            this.checkUniqueEmail = false;
          } else {
            this.checkUniqueEmail = true;
          }

        } else {
          this.checkUniqueEmail = false;
        }

      });
    }
  }
}

